import React, { useEffect, useState } from 'react';
import './Projects.scss';
import { connect } from 'react-redux';
import {
  filterProjectsAction,
  getProjectsActionRequest,
  setProjectsSortDataAction,
  sortProjectsAction,
  updateQuickFilterAction,
} from '../../store/project/projectActions';
import MercurXProjectTable from '../../components/MercurXProjectTable/MercurXProjectTable';
import { Button, Col, Form, Row, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import {
  PROJECTS_SORT_TYPES,
  projectsQuickFilterConstants,
  sortKeys,
} from './projectsConstants';

function Projects({
  getProjectsRequest,
  quickFilter,
  updateQuickFilter,
  setProjectsSortData,
  sortProjects,
  filterProjects,
}) {
  const history = useHistory();
  const [filterInput, setFilterInput] = useState('');
  const user = JSON.parse(localStorage.getItem('user'))?.user;
  useEffect(() => {
    getProjectsRequest({ filter: 'token' });
    updateQuickFilter(projectsQuickFilterConstants.ALL);
    setProjectsSortData({
      sortType: PROJECTS_SORT_TYPES.ASCENDING,
      sortKey: 0,
      sortKeys,
    });
  }, [getProjectsRequest, setProjectsSortData, updateQuickFilter]);

  useEffect(() => {
    filterProjects(filterInput);
    sortProjects();
  }, [filterInput, filterProjects, quickFilter, sortProjects]);

  function createNewProject() {
    history.push('/token-projects/create-new-project');
  }

  return (
    <>
      <div className="text-fs-head-md mb-4">Token Projects</div>
      <Row className="text-fs-body-md mt-4 text-center">
        <Col>
          <Form.Control
            className="text-fs-body-sm"
            type="text"
            placeholder="Search by token project name or token symbol..."
            aria-label="text"
            aria-describedby="basic-addon1"
            value={filterInput}
            onChange={(e) => setFilterInput(e.target.value)}
            size={'sm'}
          />
        </Col>
      </Row>
      <Row className="d-flex align-items-center justify-content-end mt-4">
        <Col className="text-md-end">
          <ToggleButtonGroup size={'sm'} type="radio" name="options" defaultValue={1}>
            <ToggleButton
              size={'sm'}
              variant={quickFilter === projectsQuickFilterConstants.ALL ? 'primary' : 'light'}
              className={
                quickFilter !== projectsQuickFilterConstants.ALL ? 'text-t-body-color' : ''
              }
              id="tbg-radio-1"
              value={projectsQuickFilterConstants.ALL}
              onClick={() => updateQuickFilter(projectsQuickFilterConstants.ALL)}
            >
              All
            </ToggleButton>
            <ToggleButton
              size={'sm'}
              variant={quickFilter === projectsQuickFilterConstants.ACTIVE ? 'primary' : 'light'}
              className={
                quickFilter !== projectsQuickFilterConstants.ACTIVE ? 'text-t-body-color' : ''
              }
              id="tbg-radio-2"
              value={projectsQuickFilterConstants.ACTIVE}
              onClick={() => updateQuickFilter(projectsQuickFilterConstants.ACTIVE)}
            >
              Active
            </ToggleButton>
            <ToggleButton
              size={'sm'}
              variant={quickFilter === projectsQuickFilterConstants.COMPLETED ? 'primary' : 'light'}
              className={
                quickFilter !== projectsQuickFilterConstants.COMPLETED ? 'text-t-body-color' : ''
              }
              id="tbg-radio-3"
              value={projectsQuickFilterConstants.COMPLETED}
              onClick={() => updateQuickFilter(projectsQuickFilterConstants.COMPLETED)}
            >
              Completed
            </ToggleButton>
          </ToggleButtonGroup>
        </Col>
      </Row>
      <div id="projects-container">
        <MercurXProjectTable />
      </div>
      <div className="text-end">
      {user.is_superuser && (
        <Button onClick={createNewProject} size={'sm'}>
          Create new token project
        </Button>
        )}
      </div>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    quickFilter: state.projectReducer.quickFilter,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getProjectsRequest: (payload) => {
      dispatch(getProjectsActionRequest(payload));
    },
    updateQuickFilter: (payload) => {
      dispatch(updateQuickFilterAction(payload));
    },
    setProjectsSortData: (payload) => {
      dispatch(setProjectsSortDataAction(payload));
    },
    sortProjects: (payload) => {
      dispatch(sortProjectsAction(payload));
    },
    filterProjects: (payload) => {
      dispatch(filterProjectsAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Projects);
